import React from "react"

import { Input } from "@coval/ui/input"

import { FieldLabel } from "@/components/shared/forms/FieldLabel"

import { CHAT_WEBSOCKET_TOOLTIPS } from "./tooltips"
import type { ChatWebSocketFieldProps } from "./types"

export const BehaviorFields: React.FC<ChatWebSocketFieldProps> = ({
  metadata,
  onMetadataUpdate,
  disabled = false,
}) => {
  return (
    <div className="space-y-4">
      <h4 className="text-sm font-medium text-coval-text">Message Behavior</h4>

      {/* Initial Message */}
      <div className="space-y-2">
        <FieldLabel
          htmlFor="initial-message"
          tooltip={CHAT_WEBSOCKET_TOOLTIPS.initialMessage}
        >
          Initial Message
        </FieldLabel>
        <Input
          id="initial-message"
          aria-label="Initial Message"
          value={metadata.initial_message ?? ""}
          placeholder="Enter a message to send on connection"
          onChange={(e) =>
            onMetadataUpdate({ initial_message: e.target.value })
          }
          disabled={disabled}
        />
      </div>

      {/* Message Coalesce Timeout */}
      <div className="space-y-2">
        <FieldLabel
          htmlFor="coalesce-timeout"
          tooltip={CHAT_WEBSOCKET_TOOLTIPS.messageCoalesceTimeout}
        >
          Message Coalesce Timeout (seconds)
        </FieldLabel>
        <Input
          id="coalesce-timeout"
          aria-label="Message Coalesce Timeout"
          type="number"
          placeholder="Set a coalesce timeout in seconds"
          min={0}
          step={0.1}
          value={
            metadata.message_coalesce_timeout_seconds != null
              ? String(metadata.message_coalesce_timeout_seconds)
              : ""
          }
          onChange={(e) => {
            const raw = e.target.value
            if (raw === "") {
              onMetadataUpdate({
                message_coalesce_timeout_seconds: undefined,
              })
            } else {
              const parsed = parseFloat(raw)
              if (!isNaN(parsed) && isFinite(parsed) && parsed >= 0) {
                onMetadataUpdate({
                  message_coalesce_timeout_seconds: parsed,
                })
              }
            }
          }}
          disabled={disabled}
        />
      </div>
    </div>
  )
}
